import { Navigate, useLocation, useParams } from "react-router-dom";
import { WEB_SIGN_UP_V6 } from "../constants/routes";

const ONE_OFF_TO_MEMBERSHIP_KEY: Record<string, string> = {
  bronze: "starter",
  silver: "starter",
  gold: "pro",
  platinum: "pro",
  diamond: "mvp",
};

export const getMembershipSignupPathFromOneOffKey = (
  oneOffKey: string | undefined,
): string => {
  const normalizedKey = (oneOffKey || "pro").toLowerCase().trim();
  const membershipKey = ONE_OFF_TO_MEMBERSHIP_KEY[normalizedKey] ?? "pro";

  return WEB_SIGN_UP_V6.replace(":subscriptionKey", membershipKey);
};

const WebOneOffSignupRedirect = () => {
  const location = useLocation();
  const { subscriptionKey } = useParams<{ subscriptionKey: string }>();

  return (
    <Navigate
      to={{
        pathname: getMembershipSignupPathFromOneOffKey(subscriptionKey),
        search: location.search,
      }}
      replace
    />
  );
};

export default WebOneOffSignupRedirect;
